import { render, staticRenderFns } from "./NewImagemHome.vue?vue&type=template&id=2287e095&scoped=true&"
import script from "./NewImagemHome.vue?vue&type=script&lang=js&"
export * from "./NewImagemHome.vue?vue&type=script&lang=js&"
import style0 from "./NewImagemHome.vue?vue&type=style&index=0&id=2287e095&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../../../frontend/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2287e095",
  null
  
)

export default component.exports